export type PostbackEvent = "registration" | "first_deposit" | "deposit"
export type PostbackMethod = "GET" | "POST"
export type PostbackFilterMode = "ALL" | "ANY"
export type PostbackStatus = "PENDING" | "SUCCESS" | "FAILED" | "SKIPPED"
export type PostbackSkipReason = "duplicate" | "filter_mismatch" | "disabled" | "ssrf_blocked"
export type AttributionMode = "last_click" | "first_click"

export type PostbackFilterField = "referral_code" | "affiliate_username"

export interface PostbackFilter {
  field: PostbackFilterField
  operator: "equals"
  value: string
}

export interface Postback {
  id: string
  name: string
  enabled: boolean
  event: PostbackEvent
  method: PostbackMethod
  url_template: string
  filter_mode: PostbackFilterMode
  filters: PostbackFilter[]
  created_at: string
  updated_at: string
}

export interface PostbackInput {
  name: string
  enabled: boolean
  event: PostbackEvent
  method: PostbackMethod
  url_template: string
  filter_mode: PostbackFilterMode
  filters: PostbackFilter[]
}

export interface TrackingConfig {
  enabled: boolean
  aliases: string[]
  attribution_mode: AttributionMode
  max_attempts: number
}

export interface PostbackLog {
  id: string
  postback_id: string | null
  postback_name: string
  event: PostbackEvent
  user_id: string | null
  transaction_id: string | null
  subid: string | null
  method: PostbackMethod
  resolved_url: string
  http_status: number | null
  response_body: string | null
  attempt_number: number
  status: PostbackStatus
  skip_reason: PostbackSkipReason | null
  error: string | null
  is_test: boolean
  next_attempt_at: string | null
  created_at: string
}

export interface LogsResult {
  rows: PostbackLog[]
  total: number
}

export interface LogFilters {
  event?: PostbackEvent
  status?: PostbackStatus
  postbackId?: string
  isTest?: boolean
  from?: string
  to?: string
  page?: number
  pageSize?: number
}

export interface TestFireResult {
  resolved_url: string
  success: boolean
  http_status: number | null
  response_body: string | null
  error: string | null
}

export const POSTBACK_EVENTS: PostbackEvent[] = ["registration", "first_deposit", "deposit"]
export const POSTBACK_METHODS: PostbackMethod[] = ["GET", "POST"]
export const POSTBACK_FILTER_MODES: PostbackFilterMode[] = ["ALL", "ANY"]
export const POSTBACK_STATUSES: PostbackStatus[] = ["PENDING", "SUCCESS", "FAILED", "SKIPPED"]

export const PLACEHOLDER_CHEAT_SHEET: { token: string; key: string }[] = [
  { token: "{subid}", key: "subid" },
  { token: "{referral_code}", key: "referralCode" },
  { token: "{deposit_amount}", key: "depositAmount" },
  { token: "{deposit_currency}", key: "depositCurrency" },
  { token: "{transaction_id}", key: "transactionId" },
  { token: "{event}", key: "event" },
  { token: "{timestamp}", key: "timestamp" }
]
